import React, { useState } from "react";
import { Grid, IconButton, InputAdornment, CircularProgress, InputLabel, OutlinedInput, TextField, Typography, FormControl, FormHelperText, Button } from '@mui/material';
import "../../Styles/Pages/ForgotPassword.css";
import instance from "../../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import forgotpassword from '../../Assets/forgotpassword.svg';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import OtpInput from 'react-otp-input';


const SuperAdminForgotPassword = () => {
  const [email, setEmail] = useState();
  const [emailError, setEmailError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [newPassword, setnewPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const handleTogglePasswordVisibility1 = () => setShowPassword1((prevShowPassword) => !prevShowPassword);
  const handleTogglePasswordVisibility2 = () => setShowPassword2((prevShowPassword) => !prevShowPassword);

  const handleOtpChange = (otpValue) => {
    setOtp(otpValue);
    setOtpError("");
  };

  const sendOtp = async () => {
    if (!email) {
      setEmailError("Email is required");
      return;
    }
    try {
      setLoading(true);
      const response = await instance.post("/superAdmin/ResetPasswordRequest", { email: email })
      if (response.status === 200) {
        toast.success(response.data.msg);
        setOpen(true);
      }
    } catch (err) {
      toast.error(err.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async () => {
    let valid = true;
    if (!otp) {
      setOtpError("OTP is required");
      valid = false;
    } else if (otp.length !== 4) {
      setOtpError("OTP must be 4 digits");
      valid = false;
    } else {
      setOtpError("");
    }
    if (!newPassword) {
      setNewPasswordError("New password required");
      valid = false;
    } else {
      setNewPasswordError("");
    }
    if (!confirmPassword) {
      setConfirmPasswordError("Please confirm password");
      valid = false;
    } else if (confirmPassword !== newPassword) {
      setConfirmPasswordError("Passwords do not match");
      valid = false;
    } else {
      setConfirmPasswordError("");
    }
    if (!valid) return;
    try {
      setLoading(true);
      const response = await instance.post("/superAdmin/ResetPasswordOTP", {
        email,
        otp,
        newPassword,
        confirmPassword,
      });
      if (response.status === 200) {
        toast.success(response.data.msg);
        setOpen(false);
        navigate("/admin/login");
      }
    } catch (err) {
      toast.error(err.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <React.Fragment>
        <section className="admin_login">
          <div className="login">
            <Grid container direction="column" spacing={3}>
              <Typography variant="h2"><img src={forgotpassword} /></Typography>
              <Typography>Enter email to get otp</Typography>
              {!open && (
                <>
                  <Grid item>
                    <TextField
                      type="email"
                      label="Enter Your Email"
                      placeholder="Email Address"
                      variant="outlined"
                      // autoComplete='off'
                      required
                      fullWidth
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value.toLowerCase());
                        setEmailError("");
                      }}
                      error={Boolean(emailError)}
                      helperText={emailError}
                    />
                  </Grid>
                </>
              )}
              {open && (
                <>
                  <Grid item>
                    <div className='otp-input'>
                      <OtpInput
                        value={otp}
                        onChange={handleOtpChange}
                        numInputs={4}
                        renderSeparator={<span></span>}
                        renderInput={(props) =>
                          <input
                            {...props}
                            style={{ border: otpError ? '1px solid #DD2020' : '1px solid #ccc', padding: "10px", width: "40px", marginRight: "8px", borderRadius: "4px", fontSize: "18px", textAlign: "center" }}
                          />}
                      />
                    </div>
                    {otpError && <div className="error-text">{otpError}</div>}
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-password1">
                        New Password
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password1"
                        type={showPassword1 ? "text" : "password"}
                        value={newPassword}
                        onChange={(e) => setnewPassword(e.target.value)}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleTogglePasswordVisibility1}
                              edge="end"
                            >
                              {showPassword1 ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="New Password"
                        fullWidth
                        error={Boolean(newPasswordError)}
                      />
                    </FormControl>
                    <FormHelperText error={Boolean(newPasswordError)}>
                      {newPasswordError}
                    </FormHelperText>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-password2">
                        Confirm Password
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password2"
                        type={showPassword2 ? "text" : "password"}
                        value={confirmPassword}
                        onChange={(e) => setconfirmPassword(e.target.value)}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleTogglePasswordVisibility2}
                              edge="end"
                            >
                              {showPassword2 ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Confirm Password"
                        fullWidth
                        error={Boolean(confirmPasswordError)}
                      />
                    </FormControl>
                    <FormHelperText error={Boolean(confirmPasswordError)}>
                      {confirmPasswordError}
                    </FormHelperText>
                  </Grid>
                </>
              )}
              <Grid item>
                <Button
                  type="submit"
                  onClick={open ? resetPassword : sendOtp}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={20} sx={{ color: "white" }} />
                  ) : (
                    open ? "Verify OTP" : "Send OTP"
                  )}
                </Button>
              </Grid>
            </Grid>
          </div>
        </section>
      </React.Fragment>
    </>
  );
}

export default SuperAdminForgotPassword;
